import React from 'react';
import InfoPopUp from "./InfoPopUp";
import Popup from "reactjs-popup";
import closePng from './../../assets/close.png';
import Button from "@material-ui/core/Button";
import {CircularProgress} from "@material-ui/core";
import requests from "../../constants/requests";
import {toast} from "react-toastify";

class AddEditPlanPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errMsg: "",
            isSubmitting: false
        }
        this.plan = this.props.isAddPlan ? {
            majors: ["", ""],
            minors: ["", "", ""],
            enteringYear: 0,
            college: ""
        } : this.props.originalPlan;

        this.originalPlan = this.props.isAddPlan ? this.plan : this.props.originalPlan;

        this.checkValidity = this.checkValidity.bind(this);
        this.setPlan = this.setPlan.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    checkValidity(plan) {
        console.log(plan);
        if(plan.majors[0] === "") {
            this.setState({ errMsg: "You must have a first major!" });
        } else if(plan.majors[0] !== "" && plan.majors[0] !== undefined && plan.majors[0] === plan.majors[1]) {
            this.setState({ errMsg: "Same majors are not allowed!" });
        } else if((plan.minors[0] !== "" && plan.minors[0] !== undefined && plan.minors[0] === plan.minors[1])
            || (plan.minors[1] !== "" && plan.minors[1] !== undefined && plan.minors[1] === plan.minors[2])
            || (plan.minors[0] !== "" && plan.minors[0] !== undefined && plan.minors[0] === plan.minors[2])) {
            this.setState({ errMsg: "Same minors are not allowed!" });
        } else if(plan.enteringYear === 0) {
            this.setState({ errMsg: "Please select an entering year!" });
        } else if(plan.college === "") {
            this.setState({ errMsg: "Please select a college!" });
        } else {
            this.setState({ errMsg: "" });
        }
    }

    setPlan(plan) {
        this.checkValidity(plan);
        this.plan = plan;
    }

    onAdd() {
        this.setState({ isSubmitting: true });
        let plan = this.plan;
        const majors = plan.majors;
        plan.majors = [];
        plan.majors.push(majors[0]);
        if(majors.length === 2 && majors[1] !== "" && majors[1] !== null) {
            plan.majors.push(majors[1]);
        }
        const minors = plan.minors;
        plan.minors = [];
        for(let i = 0; i < minors.length; i++) {
            if(minors[i] !== "" && minors[i] !== null) {
                plan.minors.push(minors[i]);
            }
        }
        fetch(requests.ADD_PLAN(), {
            method: 'POST',
            headers: requests.HEADER(),
            body: JSON.stringify({
                token: this.props.token,
                ...plan
            })
        }).then((res) => {
            res.json().then((response) => {
                this.setState({ isSubmitting: false });
                if(!response.isTokenValid) {
                    this.props.onLogout();
                }
                if(response.didAddSucceed) {
                    toast("Plan was successfully added!")
                    this.props.addPlan({
                        ...plan,
                        _id: response.plan_id,
                        name: response.plan_name,
                        coursesList: [[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]]
                    })
                    this.props.onClose();
                } else {
                    toast("Adding plan failed! " + response.errMsg);
                }
            }, (err) => {
                this.setState({ isSubmitting: false });
                toast("Adding plan failed! Unknown error!");
                console.log(err);
                console.log("Parsing response body failed.");
            });
        }).catch((err) => {
            this.setState({ isSubmitting: false });
            toast("Adding plan failed! Unknown error!");
            console.log(err);
            console.log("Adding plan failed!");
        });
    }

    onEdit() {
        this.setState({ isSubmitting: true });
        let plan = this.plan;
        const majors = plan.majors;
        plan.majors = [];
        plan.majors.push(majors[0]);
        if(majors.length === 2 && majors[1] !== "" && majors[1] !== null) {
            plan.majors.push(majors[1]);
        }
        const minors = plan.minors;
        plan.minors = [];
        for(let i = 0; i < minors.length; i++) {
            if(minors[i] !== "" && minors[i] !== null) {
                plan.minors.push(minors[i]);
            }
        }
        fetch(requests.EDIT_PLAN(this.originalPlan._id), {
            method: 'POST',
            headers: requests.HEADER(),
            body: JSON.stringify({
                token: this.props.token,
                ...plan
            })
        }).then((res) => {
            res.json().then((response) => {
                this.setState({ isSubmitting: false });
                if(!response.isTokenValid) {
                    this.props.onLogout();
                }
                if(response.didEditSucceed) {
                    toast("Plan was successfully edited!")
                    this.props.editPlan({
                        ...plan,
                        _id: this.originalPlan._id,
                        name: this.originalPlan.name,
                        coursesList: this.originalPlan.coursesList
                    })
                    this.props.onClose();
                } else {
                    toast("Editing plan failed! " + response.errMsg);
                }
            }, (err) => {
                this.setState({ isSubmitting: false });
                toast("Editing plan failed! Unknown error!");
                console.log(err);
                console.log("Parsing response body failed.");
            });
        }).catch((err) => {
            this.setState({ isSubmitting: false });
            toast("Editing plan failed! Unknown error!");
            console.log(err);
            console.log("Adding plan failed!");
        });
    }

    render() {
        return (
            <Popup
                open={ true }
                onClose={ this.props.onClose }
                closeOnDocumentClick={ !this.props.isMandatory }
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {
                        !this.props.isMandatory
                            && <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '100%' }}>
                                <img onClick={ this.props.onClose } src={ closePng } />
                            </div>
                    }
                    <div style={{ marginTop: 20, fontSize: 30, fontWeight: 'bold' }}>
                        { this.props.isAddPlan ? "Add a plan" : "Edit plan setting"}
                    </div>
                    <InfoPopUp setPlan={ this.setPlan } originalPlan={ this.originalPlan }
                               onLogout={this.props.onLogout} token={this.props.token}/>
                    <div style={{ height: 20, marginTop: 10 }}>
                        {
                            this.state.errMsg !== ""
                                && <div style={{ textAlign: "center", color: 'red' }}>
                                    { this.state.errMsg }
                                </div>
                        }
                    </div>
                    <div style={{ textAlign: "center", margin: 20 }}>
                        <Button
                            variant={'contained'}
                            style={{ borderRadius: 24 }}
                            onClick={ this.props.isAddPlan ? this.onAdd : this.onEdit }
                            disabled={ this.state.errMsg !== "" || this.state.isSubmitting }
                        >
                            {
                                this.state.isSubmitting
                                    ? <CircularProgress size={24} />
                                    : this.props.isAddPlan ? "Add" : "Edit"
                            }
                        </Button>
                    </div>
                </div>
            </Popup>
        )
    }
}

export default AddEditPlanPopup;